import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../components/index';
import UploadDragDrop from '../../../components/ComponentesBasicos/UploadDragDrop';

class ModalUploadDocumento extends Component {
  constructor() {
    super();
    this.state = {
      document: null,
      documents: [],
      legenda: null,
    };
  }

  checkIfFileCanBeSent = () => (this.state.document && this.state.legenda)

  modalDocumentUploadContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Legenda"
            maxlength="100"
            onChange={e => this.handleChange(e, 'legenda')}
            required
            value={this.state.legenda}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <UploadDragDrop
            files={this.state.documents}
            onChange={documents => this.setState({ documents })}
            onSelect={this.handleChangeFile}
            multiple={false}
            accept="application/pdf,.pdf"
            minHeight={70}
            titulo="Arraste o arquivo PDF aqui"
            subtitulo="ou clique para selecionar"
            largura="12"
          />
          {/* <FileUpload
            types=".pdf"
            onSelect={this.handleChangeFile}
            value={this.state.document}
          /> */}
          {/* <div style={{ marginTop: '4px' }}>(Tipo de arquivo permitido: PDF)</div> */}
        </Grid>
      </div>
    </React.Fragment>
  )

  modalDocumentUploadFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Anexar documento"
          onClick={this.addArquivo}
          title="Anexar"
        />
      </div>
    </React.Fragment>
  )

  addArquivo = () => {
    if (this.state.document) {
      let arquivo = {};
      arquivo = {
        chave: this.props.infoPagamento.idControlePagamento,
        documento: this.state.document,
        legenda: this.state.legenda,
      };

      this.state.arquivo = arquivo.documento;
      this.state.arquivo.legenda = arquivo.legenda;

      this.props.addArquivo(
        this.state.arquivo,
        this.props.arquivo,
      );
    }
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleChangeFile = (file) => {
    this.setState({
      document: file,
    });
  }

  handleDocumentSent = (response) => {
    this.setState(
      {
        document: null,
        legenda: null,
      },
      () => this.props.handleDocumentSent(response.headers.location),
    );
  }

  handleClose = () => {
    this.setState({ document: null }, this.props.handleModal('showDocumentUploadModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalDocumentUploadFooter()}
        conteudomodal={this.modalDocumentUploadContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Incluir documento"
      />
    );
  }
}

ModalUploadDocumento.propTypes = {
  idControlePagamento: PropTypes.string,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  handleDocumentSent: PropTypes.func,
}.isRequired;

export default ModalUploadDocumento;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/ModalUploadDocumentoMsg.jsx